import React from 'react'

const t = {
    FR: {
        specifics_expenses: {'page title': `Dépenses`,},
        'Filter by date': 'Filtrer par date',
        'Filter by category': 'Filtrer par catégorie',
        'Display amount in': 'Afficher les montants en',
        'All': 'Toutes',
        'Date': 'Date',
        'Amount': 'Montant',
        'Category': 'Catégorie',
        'Commerce': 'Commerce',
        'Unique?': 'Unique?',

        // ADD FORMS
        'Expense': 'Dépense',
        'Total': 'Total',
        'Note': 'Note',
        'newUserMessage': <>Pour commencer, vous devez entrer le nom d'au moins une catégorie...<br/>Puis une dépense.</>
    },
    EN: {
        specifics_expenses: {'page title': `Expenses`,},
        'Filter by date': 'Filter by date',
        'Filter by category': 'Filter by category',
        'Display amount in': 'Display amount in',
        'All': 'All',
        'Date': 'Date',
        'Amount': 'Amount',
        'Category': 'Category',
        'Commerce': 'Commerce',
        'Unique?': 'Unique?',

        // ADD FORMS
        'Expense': 'Expense',
        'Total': 'Total',
        'Note': 'Note',
        'newUserMessage': <>To start, you must enter the name of at least one category...<br/>Then an expense.</>
    },
    ES: {
        specifics_expenses: {'page title': `Gastos`,},
        'Filter by date': 'Filtrar por fecha',
        'Filter by category': 'Filtrar por categoría',
        'Display amount in': 'Mostrar cantidad en',
        'All': 'Todas',
        'Date': 'Fecha',
        'Amount': 'Cantidad',
        'Category': 'Categoría',
        'Commerce': 'Comercio',
        'Unique?': '¿Único?',

        // ADD FORMS
        'Expense': 'Gastos',
        'Total': 'Total',
        'Note': 'Nota',
        'newUserMessage': <>Para comenzar, debes ingresar el nombre de al menos una categoría...<br/>Luego un gasto.</>
    },
    PT: {
        specifics_expenses: {'page title': `Despesas`,},
        'Filter by date': 'Filtrar por data',
        'Filter by category': 'Filtrar por categoria',
        'Display amount in': 'Exibir valor em',
        'All': 'Todas',
        'Date': 'Data',
        'Amount': 'Quantia',
        'Category': 'Categoria',
        'Commerce': 'Comércio',
        'Unique?': 'Exclusivo?',

        // ADD FORMS
        'Expense': 'Despesa',
        'Total': 'Total',
        'Note': 'Nota',
        'newUserMessage': <>Para começar, você deve inserir o nome de pelo menos uma categoria...<br/>Depois, uma despesa.</>
    },
}

export default t